"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const permissionsService = {
  getPermissions: function (options) {
    return api.get("/Permissions", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default permissionsService;
